/* eslint-disable eqeqeq */

import { User } from '../../App';
export interface Suggestion {
    id: number;
    author: User;
    createdAt: number;
    title: string;
    description: string;
    score: number;
    isUserUpvoted: boolean | null;
    commentsCount: number; // used on the suggestion list where i don't have the actual comments
    comments: Comment[];
    status: SuggestionStatus;
}

export interface Comment {
    id: number;
    author: User;
    text: string;
    createdAt: number;
    isUserUpvoted: boolean | null;
    score: number;
}

export interface SuggestionStats {
    open: number;
    rejected: number;
    completed: number;
}

export function boolqToNum(val: boolean | null) {
    if (val == null) {
        return 0;
    } else if (val == true) {
        return 1;
    } else {
        return -1;
    }
}

export type SuggestionStatus = 'OPEN' | 'COMPLETED' | 'REJECTED';

export function IsRejected(sug: Suggestion) {
    return sug.status == 'REJECTED';
}

export function IsCompleted(sug: Suggestion) {
    return sug.status == 'COMPLETED';
}

export function IsOpen(sug: Suggestion) {
    return sug.status == 'OPEN';
}